import {
  Box,
  Flex,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect } from 'react';

import { useAiSearchContext } from '../../contexts/AiSearchContext';
import { useFilterContext } from '../../contexts/FilterProvider';
import { AiSearchFilterForm } from '../filterForms/talent-discovery/ai-search/AiSearchFilterForm';
import { AiSearchChip } from './AiSearchChip';

export const EditAiSearchChip = () => {
  const { aiGeneratedFilterIds, isAiSearchLoading, defaultAiSearchSet } =
    useAiSearchContext();
  const { activeFilterMap } = useFilterContext();

  const someFiltersAreAiGenerated = activeFilterMap
    ? Array.from(activeFilterMap.values()).some((filter) =>
        aiGeneratedFilterIds.includes(filter.id)
      )
    : false;

  const {
    isOpen: isFilterMenuOpen,
    onClose: handleCloseFilterMenu,
    onOpen: handleOpenFilterMenu,
  } = useDisclosure();

  useEffect(() => {
    if (defaultAiSearchSet) {
      handleOpenFilterMenu();
    }
  }, [defaultAiSearchSet, handleOpenFilterMenu]);

  if (!someFiltersAreAiGenerated || isAiSearchLoading) {
    return null;
  }

  return (
    <Popover
      placement="bottom-start"
      closeOnBlur={true}
      onClose={handleCloseFilterMenu}
      isOpen={isFilterMenuOpen}
      onOpen={handleOpenFilterMenu}
      autoFocus={true}
      gutter={0}
    >
      <PopoverTrigger>
        <Box>
          <AiSearchChip isGenerating={false} />
        </Box>
      </PopoverTrigger>
      <PopoverContent
        minWidth="325px"
        padding={3}
        color="navyBlue.500"
        boxShadow="2xl"
        data-testid={`ai-search-popover-content-${isFilterMenuOpen ? 'open' : 'closed'}`}
        width="fit-content"
        _focus={{ boxShadow: '2xl', outline: 'none' }}
      >
        <Flex direction="column">
          <AiSearchFilterForm
            closeMenu={handleCloseFilterMenu}
            isOpen={isFilterMenuOpen}
          />
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
